import { base } from './base';

export const halland = Object.assign({}, base, {});
